import { SxProps } from "@mui/material";

export const useHeaderStyles = () => {
  const appBarTitle: SxProps = {
    mr: 2,
    fontFamily: "Encode Sans",
    fontSize: 24,
    fontWeight: 700,
    color: "#BFA66E",
    textDecoration: "none"
  };

  return {
    appBarTitle
  };
};
